import { render, staticRenderFns } from "./CaseCreateUpdate.vue?vue&type=template&id=1561191a&scoped=true&"
import script from "./CaseCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./CaseCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./CaseCreateUpdate.vue?vue&type=style&index=0&id=1561191a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1561191a",
  null
  
)

export default component.exports